import apiFetch from "@wordpress/api-fetch";
import React, { useState, useEffect, useRef } from "react";
import {
  defineBlock,
  smartProps,
  useSmartProp,
  useInspectorControl,
  useEditor,
} from "@smartfire/gutenberg-react";
import { URLInput } from "@wordpress/editor";
import Slider from "react-slick";
import { useMedia } from "react-use-media";
import EditableText from "../shared/editable-text";
import { ReactComponent as Arrow } from "../assets/arrow-simple-left.svg";
import style from "./block.module.scss";
import "slick-carousel/slick/slick.css";
import { PanelBody, PanelRow, TextControl } from "@wordpress/components";

function Inspector() {
  const [url, setUrl] = useSmartProp("url");
  const [urlText, setUrlText] = useSmartProp("urlText");
  return (
    <>
      <PanelBody title="Configuration Lien" initialOpen={true}>
        <PanelRow>
          <URLInput
            label={"Lien tous nos partenaires"}
            value={url}
            onChange={(url) => setUrl(url)}
          />
        </PanelRow>
        <PanelRow>
          <TextControl
            label={"Texte du lien"}
            value={urlText}
            onChange={(value) => setUrlText(value)}
          />
        </PanelRow>
      </PanelBody>
    </>
  );
}

function Block({ url, urlText }) {
  const [partenaires, setPartenaires] = useState(null);
  const sliderRef = useRef();
  const isMobile = useMedia({ "max-width": style.tabletBreakpoint });
  const { isEditing } = useEditor();
  useInspectorControl(Inspector);
  useEffect(() => {
    apiFetch({ path: `smartfire/partenaires` }).then((partenaires) => {
      setPartenaires(partenaires);
    });
  }, [setPartenaires]);
  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 6000,
    responsive: [
      {
        breakpoint: parseInt(style.mobileBreakpoint.replace("px", "")),
        settings: {
          rows: 2,
          slidesToShow: 2,
        },
      },
    ],
  };
  return (
    <div className={style.block}>
      <div className={style.content}>
        <div className={style.titleBlock}>
          <EditableText
            className={style.title}
            tagName="h2"
            smartProp="title"
          />
          <div className={style.controlBar}>
            <div
              className={style.arrowLeft}
              onClick={() => !isEditing && sliderRef.current.slickPrev()}
            >
              <Arrow />
            </div>
            <div
              className={style.arrowRight}
              onClick={() => !isEditing && sliderRef.current.slickNext()}
            >
              <Arrow />
            </div>
            {url && urlText && !isMobile && (
              <>
                <div className={style.barVert} />
                <a className={style.link} href={url}>
                  {urlText}
                </a>
              </>
            )}
          </div>
        </div>
        <div className={style.bar} />
        {isMobile && (
          <a className={style.link} href={url}>
            {urlText}
          </a>
        )}
        {isEditing ? (
          <div>
            Ce bloc ne permet pas de prévisualisation dans l'administration.
          </div>
        ) : (
          <Slider ref={sliderRef} className={style.slider} {...settings}>
            {partenaires &&
              partenaires.map((partners, index) => (
                <div key={index}>
                  <div className={style.item}>
                    <img src={partners} alt="" />
                  </div>
                </div>
              ))}
          </Slider>
        )}
      </div>
    </div>
  );
}

export default defineBlock({
  Block,
  smartProps: {
    title: smartProps.string.withDefault("Ils nous font confiance"),
    url: smartProps.string.withDefault(""),
    urlText: smartProps.string.withDefault("Tous nos clients"),
  },
  setup: {
    title: "Nos partenaires",
  },
});
